import classNames from 'clsx';
import { camelCase } from 'lodash';

import styles from './StarsInfo.module.scss';

export type Type = 'info' | 'confirmation' | 'error' | 'warning';

export interface Props {
  className?: string;
  type?: Type;
  children?: React.ReactNode;
}

export const StarsInfo: React.FC<Props> = ({ type = 'info', className, children }) => (
  <div
    className={classNames(
      styles.info,
      styles[camelCase(`type-${type}`) as keyof typeof styles],
      className
    )}
  >
    {children}
  </div>
);
